function _parseQueryString(hash) {
    var match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        params = {};

    while (match = search.exec(hash)) {
        params[decode(match[1])] = decode(match[2]);
    }

    return params;
}

module.exports = {
    parse: _parseQueryString
};



// WEBPACK FOOTER //
// ./app/util/QueryString.js